// src/components/layout/StaffRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LoadingSpinner } from "../ui";
import VerifyEmailGate from "./VerifyEmailGate";

export default function StaffRoute({ children }) {
  const { user, profile, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><LoadingSpinner /></div>;
  if (!user || profile?.role !== "staff") return <Navigate to="/login" replace />;
  return <VerifyEmailGate>{children}</VerifyEmailGate>;
}
